<template>
  <div class="welfare-center-wrap" ref="welfareCenter">
    <div class="top">
      <div class="back">
        <div class="icon" @click="$emit('close')"></div>
        <div class="txt">{{ $t('boon-page-title') }}</div>
      </div>
      <div class="close">
        <div class="icon" @click="$emit('close')"></div>
      </div>
    </div>
    <div class="welfare-content">
      <div class="menu-wrap">
        <div class="menu-list">
          <template v-for="(item, index) in CONFIG">
            <div class="divider" :key="`_${index}`"></div>
            <div
              :key="index"
              class="menu-items"
              :class="{ active: item.key === crtKey, first: index === 0 }"
              @click="crtKey = item.key"
            >
              <div class="dot" v-if="item.dot"></div>
              {{ $t(item.key) }}
            </div>
          </template>
          <div class="divider"></div>
        </div>
      </div>
      <div class="body">
        <template v-for="(item, index) in CONFIG">
          <component :key="index" :is='item.comp' v-show="item.key === crtKey" :is-show="item.key === crtKey" @setDot="_ => setDot(index, _)"></component>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import FirstPay from './FirstPay.vue'
import Login from './Login.vue'
import BindAccount from './BindAccount.vue'
import InstallPC from './InstallPC.vue'
import InstallPWA from './InstallPWA.vue'
import { mapState } from 'vuex'
export default {
  name: 'Index',
  components: { FirstPay, Login, BindAccount, InstallPC, InstallPWA },
  data () {
    return {
      CONFIG: [],
      crtKey: 'welfare_title_first_charge'
    }
  },
  created () {
    this.initConfig()
  },
  computed: {
    ...mapState({
      userInfo: 'userInfo'
    })
  },
  methods: {
    initConfig () {
      if (this.$ENUM.BIND_ACCOUNT_PKGCHANNEL.includes(this.userInfo.real_pkg_channel)) {
        this.CONFIG = [
          { key: 'welfare_title_first_charge', comp: 'FirstPay', dot: false },
          { key: 'welfare_title_login', comp: 'Login', dot: false },
          { key: 'welfare_title_bind_account', comp: 'BindAccount', dot: false },
          { key: 'welfare_title_install_pc', comp: 'InstallPC', dot: false },
          { key: 'welfare_title_install_pwa', comp: 'InstallPWA', dot: false }
        ]
      } else {
        this.CONFIG = [
          { key: 'welfare_title_first_charge', comp: 'FirstPay', dot: false },
          { key: 'welfare_title_login', comp: 'Login', dot: false },
          { key: 'welfare_title_install_pc', comp: 'InstallPC', dot: false },
          { key: 'welfare_title_install_pwa', comp: 'InstallPWA', dot: false }
        ]
      }
    },
    setDot (index, _) {
      this.CONFIG[index].dot = _
    }
  }
}
</script>

<style lang="less" scoped >
.welfare-center-wrap {
  position: fixed;
  top: @headerH;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  background: url(~@/assets/img/welfare/bg.jpg) no-repeat center center;
  background-size: cover;
  .top {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    height: calc(85 * var(--unit-px));
    width: 100%;
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    .back {
      width: calc(513 * var(--unit-px));
      height: calc(85 * var(--unit-px));
      background: url(~@/assets/img/welfare/bg_back.png) no-repeat center center;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      padding-bottom: calc(10 * var(--unit-px));
      .icon {
        width: calc(119 * var(--unit-px));
        height: calc(53 * var(--unit-px));
        background: url(~@/assets/img/welfare/icon_back.png) no-repeat center center;
        background-size: 100% 100%;
        margin-left: calc(36 * var(--unit-px));
        cursor: pointer;
        flex-shrink: 0;
      }
      .txt {
        font-size: calc(38 * var(--unit-px));
        font-weight: 600;
        color: #CEC5AE;
        line-height: 1;
        text-shadow: 0px 1px 2px rgba(0,0,0,0.5);
        white-space: nowrap;
      }
    }
    .close {
      width: calc(301 * var(--unit-px));
      height: calc(85 * var(--unit-px));
      padding-bottom: calc(10 * var(--unit-px));
      position: relative;
      background: url(~@/assets/img/welfare/bg_close.png) no-repeat center center;
      background-size: 100% 100%;
      .icon {
        position: absolute;
        top: 1px;
        right: calc(30 * var(--unit-px));
        width: calc(66 * var(--unit-px));
        height: calc(66 * var(--unit-px));
        background: url(~@/assets/img/welfare/icon_close.png) no-repeat center center;
        background-size: 100% 100%;
        cursor: pointer;
      }
    }
  }
}
.welfare-content {
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  .menu-wrap {
    width: calc(259 * var(--unit-px));
    height: 100%;
    padding-top: calc(72 * var(--unit-px));
  }
  .menu-list {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    background: url(~@/assets/img/welfare/bg_menu.png) no-repeat center center;
    background-size: 100% 100%;
    padding: calc(29 * var(--unit-px)) 0;
    padding-right: calc(7 * var(--unit-px));
  }
  .menu-items {
    position: relative;
    overflow: hidden;
    height: calc(126 * var(--unit-px));
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: calc(30 * var(--unit-px));;
    line-height: 1.4;
    font-weight: 600;
    padding: 0 5px;
    color: #FFFFFF;
    cursor: pointer;
    text-align: center;
    &.active, &:hover {
      background: url(~@/assets/img/welfare/bg_menu_avtive.png) no-repeat center center;;
      background-size: 100% 100%;
      color: #473232;
    }
    .dot {
      width: calc(24 * var(--unit-px));
      height: calc(24 * var(--unit-px));
      position: absolute;
      top: 0;
      right: 0;
      background: url(~@/assets/img/welfare/dot.png) no-repeat center center;;
      background-size: 100% 100%;
    }
  }
  .divider {
    width: 100%;
    height: 1px;
    background: url(~@/assets/img/welfare/bg_menu_line.png) no-repeat center center;
    background-size: 100% 100%;
  }
  .body {
    flex: 1;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
